// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".diaBtns[data-v-74fb1a10]{width:80px;padding:10px}", ""]);
// Exports
module.exports = exports;
